/** The catalog also stores bare years, and a year is not a day. */
const FULL_DAY = /^\d{4}-\d{2}-\d{2}$/;

/**
 * `YYYY-MM-DD` out of whatever the catalog holds, or nothing.
 *
 * Nothing is a real answer here: a release with no day is not a release with
 * an unknown day, and the sheet reads the two differently.
 */
export function toReleaseDay(releaseDate: string | null | undefined): string | undefined {
  if (releaseDate === null || releaseDate === undefined) {
    return undefined;
  }
  const day = releaseDate.slice(0, 10);
  return FULL_DAY.test(day) ? day : undefined;
}
